export default __webpack_public_path__ + "static/media/cross-icon-white.2a0a579a.svg";